
export {get_search_results};

import {jersify} from './utils.js';
import {CLIP_BACKSTEP, CLIP_FORESTEP, get_action_label} from './config.js';
import {state, get_match} from './index.js';


// ---------------------------
// SEARCH RESULT CLASS
// ---------------------------

function search_result(date, pnum, pname, cat, act, rot, gnum, opp, score, created, vid, vstart, vend) {
	this.date       = date;
	this.playernum  = pnum;
	this.jerseynum  = jersify(pnum);
	this.playername = pname;
	this.category   = cat.substring(0, 1).toUpperCase() + cat.substring(1).replace('_', '-');
	this.action     = act;
	this.rotation   = rot;
	this.gamenum    = gnum;
	this.opponent   = opp;
	this.score      = score;
	this.created    = created;
	this.vid        = vid;
	this.vstart     = vstart;
	this.vend       = vend;
	this.vstate     = ((vid !== null) && (vstart >= 0) && (vend >= 0)) ? 2 : 0;
	this.ui_elem    = null;
}


// ---------------------------
// SEARCH EXECUTION
// ---------------------------

function get_search_results(_players, _rotations, _actions, _games) {
	// Init the results
	var results = [];

	// Run through all the games
	for (let h = 0; h < state.games.length; h++) {
		// Get the game
		let game = state.games[h];

		// Get the Match
		let match = get_match(game.match_id);

		// Init the score
		let score  = {};
		score.us   = 0;
		score.them = 0;

		// Check for game qualification
		if (_games.indexOf(parseInt(game.id)) < 0) {
			continue;
		}

		// Get the videos for the game
		let videos = state.videos[state.games[h].id] || [];

		// Sort the videos in reverse logix order
		videos.sort(function(a, b) {
			return (b.logix > a.logix) ? 1 : -1;
		});

		// Create an index based on the logix of the videos attached to the game
		let videoix = {};
		let stopix  = 10000;
		for (let k = 0; k < videos.length; k++) {
			videoix[videos[k].logix] = { "startix":videos[k].logix, "stopix":stopix, "vid":videos[k].vid, "secs":videos[k].secs, "offset":videos[k].offset, "basetime":null };
			stopix = videos[k].logix;
		}

		// Init the log index and the base log record
		let logix   = -1;
		let baserec = null;

		// Run through the game log
		for (let i = 0; i < game.log.length; i++) {

			// Get the log item
			let r = game.log[i];

			// Check if a log adjustment
			if (r[0] == "LogAdjustment") {
				// Go to next loop if not a log entry
				score.us   += r[3];
				score.them += r[4];
				continue;
			}

			if (r[0] == "LogTimeout" || r[0] == "LogSubstitution") {
				continue;
			}

			// Update the score
			score[r[9]] += r[10];

			// Increment the log index
			logix += 1;

			// Check if this logix matches one of the videos attached to this game
			if (videoix[logix]) {
				baserec          = videoix[logix];
				baserec.basetime = Math.floor(Date.parse(r[1]) / 1000);
			}

			let action_category = state.touch ? (game.oldlog[i].action.tags[1] || game.oldlog[i].action.tags[0]) : r[7];

			// Check for basic qualification

			// Team
			if (r[4] != 'us') {
				continue;
			}

			// Rotation
			if (!state.touch && _rotations.indexOf(parseInt(r[2])) < 0) {
				continue;
			}

			// Action category and code
			if (_actions[action_category] == undefined) {
				continue;
			}

			// Special case for assists
			if ((_players.indexOf(r[13]) >= 0) && (_actions.earned.indexOf('asst') >= 0)) {
				let date       = Math.floor(Date.parse(r[1]) / 1000);
				let playernum  = r[13];
				let playername = r[14];
				let category   = action_category;
				let action     = get_action_label(category, "asst");
				let rotation   = r[2];
				let gamenum    = state.touch ? game.name : game.num;
				let opponent   = match.opponent;
				let created    = game.created;
				let vid        = null;
				let vstart     = -1;
				let vend       = -1;

				// Check if a base log record has been set
				if (baserec) {
					// Check that the point is is in the base record's log index range
					if ((baserec.startix <= logix) && (logix < baserec.stopix)) {
						// Get the diff in seconds between this log point and the base record log point
						let dsecs = date - baserec.basetime;

						// Check if this point is in the base record's duration
						if (baserec.offset + dsecs <= baserec.secs) {
							// Sync the point
							vid    = baserec.vid;
							vstart = Math.max(baserec.offset + dsecs - CLIP_BACKSTEP, 0);
							vend   = baserec.offset + dsecs + CLIP_FORESTEP;
						}
					}
				}

				// Add the result
				results.push(new search_result(date, playernum, playername, category, action, rotation, gamenum, opponent, { 'us':score.us, 'them':score.them }, created, vid, vstart, vend));
			}

			// Check if log entry meets search category and action qualification
			if ((_players.indexOf(r[5]) >= 0) && (_actions[action_category].indexOf(r[8]) >= 0)) {
				let date       = Math.floor(Date.parse(r[1]) / 1000);
				let playernum  = r[5];
				let playername = r[6];
				let category   = action_category;
				let action     = get_action_label(category, r[8]);
				let rotation   = r[2];
				let gamenum    = state.touch ? game.name : game.num;
				let opponent   = match.opponent;
				let created    = game.created;
				let vid        = null;
				let vstart     = -1;
				let vend       = -1;

				// Check if a base log record has been set
				if (baserec) {
					// Check that the point is is in the base record's log index range
					if ((baserec.startix <= logix) && (logix < baserec.stopix)) {
						// Get the diff in seconds between this log point and the base record log point
						let dsecs = date - baserec.basetime;

						// Check if this point is in the base record's duration
						if (baserec.offset + dsecs <= baserec.secs) {
							// Sync the point
							vid    = baserec.vid;
							vstart = Math.max(baserec.offset + dsecs - CLIP_BACKSTEP, 0);
							vend   = baserec.offset + dsecs + CLIP_FORESTEP;
						}
					}
				}

				// Add the result
				results.push(new search_result(date, playernum, playername, category, action, rotation, gamenum, opponent, { 'us':score.us, 'them':score.them }, created, vid, vstart, vend));
			}
		}
	}

	return results;
}

